import { useState } from 'react';
import { fetchBuildDistributionExternalBucket } from '../../api';
import { FetchExternalBuildDistroBucketResponse } from '@/types';

export type GetExternalBucketHookResult = [
    getExternalBucket: (bucketHash: string) => Promise<FetchExternalBuildDistroBucketResponse>,
    isLoading: boolean,
    error: any,
];

export function useGetExternalBuildDistroBucket(): GetExternalBucketHookResult {
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const getExternalBucketFn = async (bucketHash: string) => {
        setIsLoading(true);
        try {
            const bucket = await fetchBuildDistributionExternalBucket({ bucketHash });

            return bucket;
        } catch (error) {
            setError(error);
        } finally {
            setIsLoading(false);
        }

        return null;
    };

    return [getExternalBucketFn, isLoading, error];
}
